import * as React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { DropTarget } from "react-dnd";
import ItemTypes from "./item-types";
import "./drag-and-drop.style.scss";

const boxTarget = {
  canDrop(props, monitor) {
    const item = monitor.getItem();
    const isOrganization = props.type === "ORGANISATIONAL_UNIT";
    const isSameOrganization = props.name !== item.name;
    const parentInChild = props.path.indexOf(item.name) !== -1;

    return isOrganization && isSameOrganization && !parentInChild;
  },
  drop(props) {
    return { id: props.name };
  },
};

export class DropWrapper extends React.Component {
  render() {
    return this.props.connectDropTarget ? (
      this.props.connectDropTarget(
        <div
          className={classNames({ "drop-active": this.props.isOver && this.props.canDrop })}
          data-id={this.props.name}
          onClick={this.props.onClick}
        >
          {this.props.children}
        </div>,
      )
    ) : (
      <div>Not connected DropWrapper</div>
    );
  }
}

DropWrapper.propTypes = {
  canDrop: PropTypes.bool,
  children: PropTypes.any,
  connectDropTarget: PropTypes.func,
  isOver: PropTypes.bool,
  type: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  path: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default DropTarget(ItemTypes.BOX, boxTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(DropWrapper);
